<div class="screen-element screen-timeset">
	<div #titleElement class="text title" [ngClass]="{'light':this.lightTitle,'dark':hasParameter('darkTitle')}" >{{title|uppercase}}</div>
	<div #subtitleElement class="text subtitle" [ngClass]="{'light':this.lightSubtitle}" >{{subtitle}}</div>
	<div class="marker"></div>
<!--	{{ menuService.currentNode.getName()}} -->
	<div #wrapElement  class="menu-elements-wrap">
		<div *ngIf="mode=='date'" class="menu-row">
			<div class="date-wrap">
				<span class="day" [ngClass]="{'active':edit == 'day'}">{{day()}}</span>.
				<span class="month" [ngClass]="{'active':edit == 'month'}">{{month()}}</span>.
				<span class="year" [ngClass]="{'active':edit == 'year'}">{{year()}}</span>
			</div>	
		</div>
		<div *ngIf="mode=='time'" class="menu-row">
			<div class="date-wrap">
				<span class="hour" [ngClass]="{'active':edit == 'hour'}">{{hour()}}</span>:
				<span class="minute" [ngClass]="{'active':edit == 'minute'}">{{minute()}}</span>
			</div>
		</div>

	</div>
	<div *ngIf="hasParameter('showText')" class="texts">
		<div class="text text-1" [ngClass]="{'light':this.lightText}" >{{getText(0)}}</div>
		<div class="text text-2" [ngClass]="{'light':this.lightText}" >{{getText(1)}}</div>
	</div>
</div>